import { dateTime } from '../../shared/packages/dateTime';

export const getOverlappingAcceptances = (
  data,
  fromDate,
  toDate,
  acceptanceId
) => {
  if (!Array.isArray(data) || !fromDate || !toDate) return;

  const result = data.filter((item) => {
    const from = dateTime(item.fromDate);
    const to = dateTime(item.toDate);

    return (
      to.isSameOrAfter(fromDate, 'day') &&
      from.isSameOrBefore(toDate, 'day') &&
      item.id !== acceptanceId
    );
  });

  return result.length ? result : undefined;
};
